import { styled } from "styled-components";

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  padding: 20px;
`;

export const FormCard = styled.div`
  background: white;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 450px;
  overflow: hidden;
`;

export const Header = styled.div`
  background: #4a6cf7;
  color: white;
  padding: 25px;
  text-align: center;
  
  h2 {
    font-weight: 600;
    margin: 0;
  }
`;

export const FormContainer = styled.div`
  padding: 30px;
`;

export const InputGroup = styled.div`
  margin-bottom: 20px;
  
  label {
    display: block;
    margin-bottom: 8px;
    font-weight: 500;
    color: #333;
  }
  
  input {
    width: 100%;
    padding: 14px;
    border: 1px solid #ddd;
    border-radius: 6px;
    font-size: 16px;
    transition: border-color 0.3s;
    
    &:focus {
      border-color: #4a6cf7;
      outline: none;
      box-shadow: 0 0 0 3px rgba(74, 108, 247, 0.1);
    }
    
    &:disabled {
      background-color: #f5f5f5;
      cursor: not-allowed;
    }
  }
`;

export const Button = styled.button`
  width: 100%;
  padding: 14px;
  background-color: #4a6cf7;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s;
  
  &:hover {
    background-color: #3a5cd8;
  }
  
  &:disabled {
    background-color: #a0a0a0;
    cursor: not-allowed;
  }
`;

export const Message = styled.div`
  padding: 12px;
  border-radius: 6px;
  margin-top: 20px;
  text-align: center;
  font-size: 14px;
`;

export const ErrorMessage = styled(Message)`
  background-color: #ffebee;
  color: #d32f2f;
  border: 1px solid #ffcdd2;
`;

export const SuccessMessage = styled(Message)`
  background-color: #e8f5e9;
  color: #2e7d32;
  border: 1px solid #c8e6c9;
`;

export const InfoText = styled.p`
  text-align: center;
  color: #666;
  font-size: 14px;
  margin-top: 30px;
  line-height: 1.5;
`;

export const ResendLink = styled.div`
  text-align: center;
  margin-top: 15px;
  
  span {
    color: #666;
    font-size: 14px;
  }
  
  button {
    background: none;
    border: none;
    color: #4a6cf7;
    cursor: pointer;
    font-size: 14px;
    text-decoration: underline;
    
    &:hover {
      color: #3a5cd8;
    }
    
    &:disabled {
      color: #a0a0a0;
      cursor: not-allowed;
    }
  }
`;